// extracted by mini-css-extract-plugin
module.exports = {"card":"v1_card__vZ8Zq","active":"v1_active___1OE2","img":"v1_img__Pkq7P","text":"v1_text___e43I"};